import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const OrganizationTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    {
      label: "My Profile",
      path: "/admin/myprofile"
    },
    {
      label: "Operations",
      path: "/admin/operations"
    },
    {
      label: "Business Units",
      path: "/admin/organization/add"
    },
    {
      label: "Legal Entities",
      path: "/admin/legalentities"
    },
    {
      label: "Locations",
      path: "/admin/locations"
    },
    {
      label: "Contacts",
      path: "/admin/contacts"
    }
  ];

  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  return (
    <div className="tenant-people-tabs">
      {tabs.map((tab) => (
        <button
          key={tab.path}
          type="button"
          className={`tenant-people-tab ${
            isActive(tab.path) ? "tenant-people-tab-active" : ""
          }`}
          onClick={() => navigate(tab.path)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default OrganizationTabs;